import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { GoogleLogin as GoogleLoginButton } from "@react-oauth/google";
import urls from "../../../Utility/URL/url";
import constant from "../../../Utility/Constants/constant";
import dataStored from "../../../Utility/DataStoring/dataStored";

const GoogleLogin = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleLoginSuccess = (credentialResponse) => {
    const idToken = credentialResponse?.credential;
    if (!idToken) {
      alert("Google login failed. No token received.");
      return;
    }

    // console.log("Google Response:", credentialResponse);
    setIsLoading(true);

    axios
      .post(
        urls.Post_LOGIN_WITH_GOOGLE,
        { googleIdToken: idToken, isAdvisor: 1 },
        { headers: { "Content-Type": "application/json" } }
      )
      .then((res) => {
  if (res.status === 200) {
    const data = res.data;
    // console.log("Login success:", data); 

    // Save token and user info in localstorage as firebase hosting redirection of tabs will loss the data.
    localStorage.setItem(constant.AUTH_TOKEN, data.accessToken || data.token);
    localStorage.setItem(constant.ABD_SESSION, JSON.stringify(data));

    /* storing the data in session storage without it dashboard/home will not load */
    /* it's a utility function */
    dataStored(constant.ABD_SESSION, data);
    dataStored(constant.AUTH_TOKEN, data.accessToken || data.token);


    // ✅ Redirect to Home with username
    //  navigate(`/${data.username}`, { replace: true });
    /* after login dont route this to username as it will redirect you to localhost:3000/:username component specified in the app.js 
     * route this to the dashboard/Home it will go to home page
    */
    navigate(`/dashboard/Home`, { replace: true });
  }
})

      .catch((err) => {
        const status = err.response?.status;
        console.error("Backend login failed:", status, err);

        if (status === 404 || status === 500) {
          // User not found → go to signup
          alert("User not found. Redirecting to Signup...");
          navigate("/signup");
        } else {
          alert("Something went wrong. Please try again.");
        }
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      {isLoading ? (
        <p>Logging you in...</p>
      ) : (
        <GoogleLoginButton
          onSuccess={handleLoginSuccess}
          onError={() => alert("Google Login Failed")}
        />
      )}
    </div>
  );
};

export default GoogleLogin;
